module.exports = __webpack_public_path__ + "static/img/logo-default.37c3ea6b.png";